import { Pill, Tooltip } from "@mantine/core";

import type { Workspace } from "@/supabase.types";

interface WorkspaceAbbreviationChipProps extends Partial<Workspace> {}

export const WorkspaceAbbreviationChip = ({ name, abbreviation }: WorkspaceAbbreviationChipProps) => {
  if (!abbreviation) return null;
  return (
    <Tooltip label={name} disabled={!name}>
      <Pill variant="contrast" size="sm">
        {abbreviation}
      </Pill>
    </Tooltip>
  );
};

export default WorkspaceAbbreviationChip;
